var exports = {
  "N": "ProfileCardFooter.module__footerSection___aFN3T0",
};

module.exports = exports;
